// @src - https://gist.github.com/admicaa/abfbb07507b57336fb491b92b90860c2#file-google-maps-parser-js
// @src - https://developers.google.com/maps/documentation/geocoding/requests-geocoding#Types
var translationLookup = {
    streetNumber: ['street_number'],
    postalZip: ['postal_code'],
    street: ['street_address', 'route'],
    provinceState: [
        'administrative_area_level_1',
        // 'administrative_area_level_2',
        // 'administrative_area_level_3',
        // 'administrative_area_level_4',
        // 'administrative_area_level_5',
    ],
    city: [
        'locality',
        // 'sublocality',
        // 'sublocality_level_1',
        // 'sublocality_level_2',
        // 'sublocality_level_3',
        // 'sublocality_level_4',
    ],
    country: ['country'],
};
/**
 * Translate an ugly array of GeocoderAddressComponent's to a more user friendly format.
 *
 * e.g. [{ long_name: "1234", short_name: "1234", types: ['administrative_area_level_1', 'political']
 * -> { provinceState: { long_name: "1234", short_name: "1234" }}
 */
export default function transformPlaceResultToAddressValues(result) {
    // Loop over the lookup...
    return Object.entries(translationLookup).reduce((accumulator, [key, typesArray]) => {
        var _a;
        //... find the address_component who's types include the types from the lookup
        const foundComponent = (_a = result.address_components) === null || _a === void 0 ? void 0 : _a.find(({ types }) => {
            const intersection = types.filter((x) => typesArray.includes(x));
            return intersection.length > 0;
        });
        if (foundComponent) {
            accumulator[key] = Object.assign({}, foundComponent);
        }
        else {
            accumulator[key] = null;
        }
        return accumulator;
    }, {});
}
//# sourceMappingURL=index.js.map